<template>
  <div class="animated-fade-in">
    <!-- Filtros e histórico -->
    <v-card
      elevation="2"
      class="modern-card mb-3 rounded-te-xl"
    >
      <v-card-text class="pa-3">
        <v-checkbox
          v-model="isMeusAtendimentos"
          color="primary"
          hide-details
          label="Meus atendimentos"
          density="compact"
          class="mb-2"
        />
        
        <v-chip-group
          v-model="filtros"
          column
          multiple
          class="my-2"
        >
          <v-chip 
            small 
            filter 
            variant="outlined" 
            value="Laudo"
            class="status-badge status-badge--success"
          >
            Laudo
          </v-chip>
          <v-chip 
            small 
            filter 
            variant="outlined" 
            value="Prontuário"
            class="status-badge status-badge--primary"
          >
            Prontuário
          </v-chip>
          <v-chip 
            small 
            filter 
            variant="outlined" 
            value="Solicitação"
            class="status-badge status-badge--info"
          >
            Solicitação
          </v-chip>
          <v-chip 
            small 
            filter 
            variant="outlined" 
            value="Prescrição"
            class="status-badge status-badge--warning"
          >
            Prescrição
          </v-chip>
        </v-chip-group>
        
        <v-text-field
          v-model="buscaConteudo"
          append-icon="search"
          label="Buscar no conteúdo"
          variant="outlined"
          density="compact"
          hide-details
          class="mb-2 premium-field"
        />
      </v-card-text>
      
      <v-divider class="my-1" />
      
      <!-- <v-card-text class="scrollbar-custom scrollable-content pa-3">
        <div v-for="(grupo, index) in gruposFiltrados" :key="index" class="mb-3">
          <v-divider class="my-2" v-if="index > 0"></v-divider>
          
          <div class="d-flex align-center mb-2">
            <v-icon color="primary" size="small" class="mr-2">calendar_today</v-icon>
            <strong class="text-primary">{{ grupo.data }}</strong>
          </div>
          
          <div v-for="(item, i) in grupo.itens" :key="i" class="interactive-item pa-2 mb-2">
            <div class="text-subtitle-2 font-weight-medium mb-1">
              <strong :class="getTipoClasse(item.tipo)">{{ item.tipo }}</strong> -
              <strong class="text-primary">{{ item.prestador || '' }}</strong>
            </div>
            <div class="text-caption my-1 ml-2 conteudo-preview" v-html="item.conteudo"></div>
          </div>
        </div>
        
        <v-alert 
          v-if="gruposFiltrados.length === 0" 
          type="info" 
          variant="tonal" 
          class="empty-state mt-3"
          border="start" 
          color="primary"
        >
          <template v-slot:prepend>
            <v-icon color="primary" class="empty-icon">info</v-icon>
          </template>
          <div class="empty-text">Nenhum atendimento encontrado</div>
        </v-alert>
      </v-card-text> -->
      <v-card-text class="scrollbar-custom scrollable-content pa-3">
        <div
          v-for="(grupo, index) in gruposFiltrados"
          :key="index"
        >
          <!-- Divisor entre grupos -->
          <v-divider
            v-if="index > 0"
            class="my-3"
          />
    
          <!-- Cabeçalho do grupo -->
          <div class="d-flex align-center mb-3">
            <v-icon
              color="primary"
              size="small"
              class="mr-2"
            >
              calendar_today
            </v-icon>
            <strong class="text-primary">{{ grupo.data }}</strong>
          </div>
    
          <!-- Itens do grupo -->
          <div 
            v-for="(item, i) in grupo.itens" 
            :key="i" 
            class="interactive-item pa-3 mb-3 rounded-lg"
          >
            <!-- Divisor entre itens -->
            <v-divider
              v-if="i > 0"
              class="mb-3"
            />
      
            <!-- Conteúdo do item -->
            <div class="text-subtitle-2 font-weight-medium mb-2 text-left">
              <span :class="getTipoClasse(item.tipo)">{{ item.tipo }}</span>
              <span class="mx-1 text-grey">-</span>
              <span class="text-primary">{{ item.prestador || '' }}</span>
            </div>
      
            <div
              class="text-caption ml-2 conteudo-preview text-left"
              v-html="item.conteudo"
            />
          </div>
        </div>
  
        <!-- Estado vazio -->
        <v-alert 
          v-if="gruposFiltrados.length === 0" 
          type="info" 
          variant="tonal" 
          class="empty-state mt-3 text-left"
          border="start" 
          color="primary"
        >
          <template #prepend>
            <v-icon
              color="primary"
              class="empty-icon"
            >
              info
            </v-icon>
          </template>
          <div class="empty-text">
            Nenhum atendimento encontrado
          </div>
        </v-alert>
      </v-card-text>
    </v-card>
    
    <!-- Detalhes do Laudo selecionado -->
    <v-card 
      v-if="laudoSelecionado != null" 
      variant="outlined"
      class="modern-card detailed-card animated-fade-in"
    >
      <div class="gradient-header gradient-header--success pa-3">
        <v-toolbar
          density="compact"
          flat
          color="transparent"
        >
          <v-icon
            color="white"
            :icon="iconLaudo"
            class="mr-2"
          />
          <v-toolbar-title class="text-white">
            Detalhes do Laudo
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            color="white"
            icon
            variant="text"
            class="premium-btn"
            @click="fecharDetalhesLaudo"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </div>
      
      <v-list
        density="compact"
        class="pa-3"
      >
        <v-list-item class="info-card">
          <v-list-item-title class="text-primary font-weight-bold">
            {{ listaLaudos[laudoSelecionado].DataHora }}
          </v-list-item-title>
          <v-list-item-subtitle class="mt-1">
            <strong class="text-caption text-primary">{{ listaLaudos[laudoSelecionado].Prestador }}</strong>
          </v-list-item-subtitle>
          <v-list-item-subtitle class="text-caption text-medium-emphasis mt-1">
            {{ listaLaudos[laudoSelecionado].Exame }}
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
      
      <v-divider />
      
      <v-card-text 
        v-if="listaLaudos[laudoSelecionado] && listaLaudos[laudoSelecionado].descricaoLaudo"
        class="conteudo-detalhado pa-4 scrollbar-custom"
        v-html="listaLaudos[laudoSelecionado].descricaoLaudo"
      />
    </v-card>
    
    <!-- Detalhes do Prontuário selecionado -->
    <v-card 
      v-if="prontuarioSelecionado != null" 
      variant="outlined"
      class="modern-card detailed-card animated-fade-in"
    >
      <div class="gradient-header gradient-header--primary pa-3">
        <v-toolbar
          density="compact"
          flat
          color="transparent"
        >
          <v-icon
            color="white"
            :icon="iconProntuario"
            class="mr-2"
          />
          <v-toolbar-title class="text-white">
            Detalhes do Prontuário
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            color="white"
            icon
            variant="text"
            class="premium-btn"
            @click="fecharDetalhesProntuario"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </div>
      
      <v-divider />
      
      <v-list
        density="compact"
        class="pa-3"
      >
        <v-list-item class="info-card">
          <v-list-item-title class="text-primary font-weight-bold">
            {{ listaProntuarios[prontuarioSelecionado].DataHora }}
          </v-list-item-title>
          <v-list-item-subtitle class="mt-1">
            <strong class="text-caption text-primary">{{ listaProntuarios[prontuarioSelecionado].Prestador }}</strong>
          </v-list-item-subtitle>
          <v-list-item-subtitle class="text-caption text-medium-emphasis mt-1">
            {{ listaProntuarios[prontuarioSelecionado].Exame }}
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
      
      <v-card-text
        v-if="prontuarios[0] && prontuarios[0].prontuario && prontuarios[0].prontuario.descricao"
        class="conteudo-detalhado pa-4 scrollbar-custom"
        v-html="prontuarios[0].prontuario.descricao"
      />
    </v-card>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted } from 'vue'
import medicoService from '../../../services/medico.service'

export default {
  name: 'AtendimentosComponent',
  
  props: {
    user: {
      type: Object,
      required: true
    },
    idPaciente: {
      type: [String, Number],
      required: true
    }
  },
  
  emits: [
    'filtros-alterados', 
    'busca-alterada',
    'meus-atendimentos-alterado',
    'laudo-selecionado',
    'prontuario-selecionado',
    'lista-prontuarios'
  ],
  
  setup(props, { emit }) {
    // Refs para estado reativo
    const isMeusAtendimentos = ref(true)
    const buscaConteudo = ref('')
    const filtros = ref(['Laudo', 'Prontuário', 'Solicitação', 'Prescrição'])
    const prontuarioSelecionado = ref(null)
    const laudoSelecionado = ref(null)
    
    // Constantes para ícones e cores
    const iconLaudo = ref('content_paste')
    const iconProntuario = ref('assignment')
    
    // Dados
    const listaConsultas = ref([])
    const listaProntuarios = ref([])
    const listaLaudos = ref([])
    const prontuarios = ref([])

    // Computed para agrupamento e filtros
    const gruposFiltrados = computed(() => {
      const agrupado = {}
      
      listaConsultas.value.forEach(item => {
        const data = item.data ? item.data.split(" ")[0] : "Sem data"
        
        // ✅ Inicializa agrupamento
        if (!agrupado[data]) {
          agrupado[data] = []
        }
        
        // ✅ Aplica filtro por tipo
        if (filtros.value.length && !filtros.value.includes(item.tipo)) return
        
        // ✅ Aplica filtro por "Meus atendimentos"
        if (isMeusAtendimentos.value && item.idmedico !== props.user.id) return
        
        // ✅ Aplica busca no conteúdo (HTML ou texto)
        if (buscaConteudo.value.trim()) {
          const textoPlano = item.conteudo.replace(/<[^>]*>/g, "").toLowerCase()
          if (!textoPlano.includes(buscaConteudo.value.toLowerCase())) return
        }
        
        agrupado[data].push(item)
      })
      
      // ✅ Filtra datas que têm pelo menos 1 item
      const datasValidas = Object.keys(agrupado).filter(
        data => agrupado[data].length > 0
      )
      
      // ✅ Ordena e retorna apenas grupos com conteúdo
      return datasValidas
        .sort(
          (a, b) =>
            new Date(b.split("/").reverse().join("/")) -
            new Date(a.split("/").reverse().join("/"))
        )
        .map(data => ({ data, itens: agrupado[data] }))
    })

    // Métodos
    const getTipoClasse = (tipo) => {
      switch (tipo) {
        case 'Prontuário': return 'text-primary'
        case 'Laudo': return 'text-success'
        case 'Solicitação': return 'text-info'
        case 'Prescrição': return 'text-warning'
        default: return 'text-medium-emphasis'
      }
    }

    const fecharDetalhesLaudo = () => {
      laudoSelecionado.value = null
      emit('laudo-selecionado', null)
    }

    const fecharDetalhesProntuario = () => {
      prontuarioSelecionado.value = null
      emit('prontuario-selecionado', null)
    }

    const selecionarLaudo = (index) => {
      laudoSelecionado.value = index
      emit('laudo-selecionado', listaLaudos.value[index])
    }

    const selecionarProntuario = (index) => {
      prontuarioSelecionado.value = index
      emit('prontuario-selecionado', listaProntuarios.value[index])
    }

    // Função para carregar a lista de consultas
    const retornarListaConsultas = () => {
      medicoService.medico.retornarListaConsultas(props.idPaciente).then((r) => {
        if (r.status == 200) { 
          listaConsultas.value = r.data.dados
          processarListaConsultas()
        }
      })
    }

    const processarListaConsultas = () => {
      listaProntuarios.value = []
      listaLaudos.value = []
      
      listaConsultas.value.forEach(item => {
        if (item.tipo === 'Prontuário') {
          listaProntuarios.value.push(item)
        } else if (item.tipo === 'Laudo') {
          listaLaudos.value.push(item)
        }
      })
      
      emit('lista-prontuarios', listaProntuarios.value)
    }

    // Funções de utilidade
    const limparFiltros = () => {
      filtros.value = []
      buscaConteudo.value = ''
      isMeusAtendimentos.value = false
    }

    const aplicarFiltroPadrao = () => {
      filtros.value = ['Laudo', 'Prontuário', 'Solicitação', 'Prescrição']
      isMeusAtendimentos.value = true
      buscaConteudo.value = ''
    }

    const adicionarFiltroTipo = (tipo) => {
      if (!filtros.value.includes(tipo)) {
        filtros.value.push(tipo)
      }
    }

    const removerFiltroTipo = (tipo) => {
      filtros.value = filtros.value.filter(t => t !== tipo)
    }

    const buscarNoConteudo = (texto) => {
      buscaConteudo.value = texto
    }

    // Watchers para emitir eventos quando os filtros mudam
    watch(filtros, (novosFiltros) => {
      emit('filtros-alterados', novosFiltros)
    })

    watch(buscaConteudo, (novaBusca) => {
      emit('busca-alterada', novaBusca)
    })

    watch(isMeusAtendimentos, (novoValor) => {
      emit('meus-atendimentos-alterado', novoValor)
    })

    // Carregar dados quando o componente for montado
    onMounted(() => {
      retornarListaConsultas()
    })

    // Watch para recarregar quando o paciente mudar
    watch(() => props.idPaciente, (novoId) => {
      if (novoId) {
        retornarListaConsultas()
      }
    })

    return {
      // Refs
      isMeusAtendimentos,
      buscaConteudo,
      filtros,
      prontuarioSelecionado,
      laudoSelecionado,
      listaConsultas,
      listaProntuarios,
      listaLaudos,
      prontuarios,
      
      // Constantes
      iconLaudo,
      iconProntuario,
      
      // Computed
      gruposFiltrados,
      
      // Métodos públicos
      getTipoClasse,
      fecharDetalhesLaudo,
      fecharDetalhesProntuario,
      selecionarLaudo,
      selecionarProntuario,
      retornarListaConsultas,
      limparFiltros,
      aplicarFiltroPadrao,
      adicionarFiltroTipo,
      removerFiltroTipo,
      buscarNoConteudo
    }
  }
}
</script>

<style scoped>
.scrollable-content {
  max-height: clamp(240px, 60vh, 600px);
  overflow-y: auto;
}

.interactive-item {
  border: 1px solid rgba(var(--v-theme-on-surface), 0.12);
  border-radius: 8px;
  transition: all 0.3s ease;
  background: rgb(var(--v-theme-surface));
}

.interactive-item:hover {
  background: rgba(var(--v-theme-on-surface), 0.04);
  border-color: rgb(var(--v-theme-primary));
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(var(--v-theme-on-surface), 0.1);
}

.conteudo-preview {
  line-height: 1.4;
  color: rgb(var(--v-theme-on-surface));
}

.conteudo-preview ::v-deep(p) {
  margin-bottom: 0.5rem;
}

.conteudo-preview ::v-deep(ul),
.conteudo-preview ::v-deep(ol) {
  margin-left: 1rem;
  margin-bottom: 0.5rem;
}

.conteudo-preview ::v-deep(li) {
  margin-bottom: 0.25rem;
}

.empty-state {
  border-left: 4px solid rgb(var(--v-theme-primary));
}

.empty-icon {
  margin-right: 12px;
}

.empty-text {
  font-weight: 500;
}

/* Scrollbar personalizada */
.scrollbar-custom::-webkit-scrollbar {
  width: 6px;
}

.scrollbar-custom::-webkit-scrollbar-track {
  background: rgba(var(--v-theme-on-surface), 0.04);
  border-radius: 3px;
}

.scrollbar-custom::-webkit-scrollbar-thumb {
  background: rgba(var(--v-theme-on-surface), 0.2);
  border-radius: 3px;
}

.scrollbar-custom::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-theme-on-surface), 0.3);
}

.text-left {
  text-align: left;
}
.detailed-card {
  max-height: clamp(260px, 65vh, 520px);
  overflow-y: auto;
  margin-top: 12px;
}

.conteudo-preview {
  max-height: none !important;
  overflow: visible !important;
  text-overflow: unset !important;
  display: block !important;
  -webkit-line-clamp: unset !important;
  -webkit-box-orient: unset !important;
  white-space: normal !important;
}

.conteudo-detalhado {
  max-height: clamp(200px, 45vh, 360px);
  overflow-y: auto;
  line-height: 1.6;
}

.text-subtitle-2 {
  font-size: 0.875rem;
}

.text-caption {
  font-size: 0.75rem;
}

/* Estilos para o conteúdo HTML renderizado */
:deep(.conteudo-detalhado) p {
  margin-bottom: 0.75rem;
  line-height: 1.6;
}

:deep(.conteudo-detalhado) strong {
  color: rgb(var(--v-theme-primary));
  font-weight: 600;
}

:deep(.conteudo-detalhado) ul,
:deep(.conteudo-detalhado) ol {
  padding-left: 1.5rem;
  margin: 0.5rem 0;
}

:deep(.conteudo-detalhado) li {
  margin-bottom: 0.25rem;
}

:deep(.conteudo-preview) {
  color: rgba(var(--v-theme-on-surface), 0.7);
}

/* Estilos mais discretos para os badges de status com outlined */
:deep(.status-badge--success.v-chip--selected) {
  background: transparent !important;
  border-color: rgb(var(--v-theme-success)) !important;
  color: rgb(var(--v-theme-success)) !important;
  font-weight: 600;
  border-width: 2px;
}

:deep(.status-badge--primary.v-chip--selected) {
  background: transparent !important;
  border-color: rgb(var(--v-theme-primary)) !important;
  color: rgb(var(--v-theme-primary)) !important;
  font-weight: 600;
  border-width: 2px;
}

:deep(.status-badge--info.v-chip--selected) {
  background: transparent !important;
  border-color: rgb(var(--v-theme-info)) !important;
  color: rgb(var(--v-theme-info)) !important;
  font-weight: 600;
  border-width: 2px;
}

:deep(.status-badge--warning.v-chip--selected) {
  background: transparent !important;
  border-color: rgb(var(--v-theme-warning)) !important;
  color: rgb(var(--v-theme-warning)) !important;
  font-weight: 600;
  border-width: 2px;
}

/* Efeito hover sutil para os badges */
:deep(.status-badge.v-chip--selected:hover) {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

/* Responsividade */
@media (max-width: 768px) {
  .scrollable-content {
    max-height: clamp(220px, 55vh, 420px);
  }
}

@media (max-width: 480px) {
  .scrollable-content {
    max-height: clamp(200px, 52vh, 360px);
  }
}
</style>
